$(document).on("click", ".ps-vt-content .video-wrapper:not(.ps-video-added)", function() {
    // Mark the video as added to avoid multiple replacements
    $(this).addClass('ps-video-added');

    // Get the YouTube video ID from the data attribute
    var videoId = $(this).data('youtube-id') || 'PtcyDGoVTm0';

    // Replace the image with the YouTube embed
    $(this).html('<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + videoId + '?autoplay=1" allowfullscreen></iframe>');
});